/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Card from "metabase/components/Card";
import Icon from "metabase/components/Icon";
import { Skeleton, Tabs, List, Divider } from "antd";
import "./SearchResultsModal.css";
import Link from "metabase/core/components/Link";
import { useQuery } from "react-query";
import { elasticSearch } from "metabase/new-service";
import { useDebounce } from "ahooks";
import { getProject } from "metabase/lib/project_info";
import { formatTitle } from "metabase/lib/formatting";
import * as Urls from "metabase/lib/urls";
import { getSearchTexts } from "metabase/nav/components/utils";
import NoData from "metabase/ab/components/Dashboards/nodata";
import Highlighter from "react-highlight-words";
import formatDate from "metabase/ab/utils/date";
import { navigationBarSearch, navigationSearchHot } from '../../new-service';
import { withRouter } from 'react-router';
import { Tag } from 'antd';
import { capitalize } from "lodash";
import NoDataForProject from '../../ab/components/Dashboards/NoDataForProject';
import { Avatar } from 'antd';
import { getGrowthProjectPath } from "metabase/ab/utils/utils";
const SearchResultsModal = ({
  searchText,
  activeTabCallback,
  user,
  setLoginModalShow,
  projectId,
  router,
  loadCurrentFgaProject,
  tagOnClick,
  isAll,
  project,
  gameList,
}) => {
  const qs = getSearchTexts(searchText);

  const params = {
    // type: "all",
    keyword: qs,
    // pageSize: 10,
    // current: 1,
    // currentProject: projectId,
    // isFilterProject: !isAll
  };

  const { data, isLoading } = useQuery(
    ["navigationBarSearch", params],
    async () => {
      return navigationBarSearch(params);
    },
    {
      enabled: !!searchText,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  const { data: hotData, isLoading: hotDataLoading } = useQuery(
    ["navigationSearchHot"],
    async () => {
      return navigationSearchHot();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  const renderHotTags = () => {
    if (qs.length > 0) {
      return null;
    }
    return hotDataLoading ?
      <div style={{padding: '10px', margin: '10px'}}>
        <Skeleton active />
      </div>
     : <div className="search-results-modal__tags">
      <span className="text-sm" style={{color: '#959DA9'}}>Quick Search:</span>
      <div className="flex flex-wrap" style={{rowGap: '20px'}}>
        {hotData?.map((tag, index) => (
        <Tag key={index}
          onClick={() => {
            tagOnClick(tag.value)
          }}
          style={{
            cursor: 'pointer',
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '20px',
            padding: '4px 12px',
            border: '1px solid #959DA9',
            transition: 'background-color 0.3s'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'rgba(149, 157, 169, 0.2)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >{tag.value}</Tag>
      ))}
      </div>
    </div>
  }
  const RequiresPermission = () => {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        color: '#FFBA68',
        padding: '8px 12px',
        borderRadius: 4,
        backgroundColor: 'rgba(255, 186, 104, 0.08)',
        transition: 'all 0.2s ease'
      }}>
        <Icon name="ab_warning" size={16} />
        <span style={{
          fontSize: 12,
          fontWeight: 500,
          lineHeight: '1.3',
          letterSpacing: '0.01em'
        }}>
          Requires Permission
        </span>
      </div>
    );
  };
  const renderFooter = () => {
    if (isLoading || data?.data?.length === 0 || qs.length === 0) {
      return null;
    }
    return (
      <div
        className="search-results-modal__footer cursor-pointer"
        onClick={() => {
          router.push(getGrowthProjectPath(project?.projectName, `search-page?keyword=${searchText}`))
        }}
      >
        <span className="text-sm" >View all {data?.data?.length} results in Telegraph Bay {">"}</span>
      </div>
    )
  }
  return (
    <div className="search-results-modal">
      <Card className="search-results-modal__card" dark width="620px" >
        {isLoading ? (
          <div className="flex justify-center items-center h-full" style={{padding: 10, margin: 10}}>
            <Skeleton active />
          </div>
        ) : (
          <>
            <div className="search-results-list" style={{
              margin: !isLoading && searchText ? '10px 0 10px 0' : '0',
              padding: !isLoading && searchText ? '0 8px' : '0',
              scrollbarWidth: 'thin',
              scrollbarColor: '#666 #1A1C21',
              '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#1A1C21',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#666',
              borderRadius: '4px',
            }
          }}>
            {!searchText ? (
              <>  </>
            ) : data?.data?.length === 0 ? (
              <NoData />
            ) : data?.data?.filter(item => item.projectId === projectId).length === 0 ? (
              <NoDataForProject project={gameList?.find(game => game.id === projectId)} />
            ) : (
              <>
                {data?.data
                ?.filter(item => item.projectId === projectId)
                ?.map((item, index) => (
                  <Link
                    key={index}
                    to={`/ab/project/${item.projectName}/${item.menuValue}`}
                  >
                    <List.Item
                      className="search-result-item"
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.projectId !== projectId) {
                          loadCurrentFgaProject(item.projectId);
                        }
                        if (!item.hasPermission) {
                          return
                        }
                        const queryParams = item.type === 'chart' ? `scrollChartId=${item.cardId}` : '';
                        const url = `/ab/project/${item.projectName}/${item.menuValue}?${queryParams}`;
                        router.push(url);
                        console.log("search jump", url)
                      }}
                      style={{cursor: 'pointer'}}
                    >
                      <div className="flex">
                        <div style={{marginRight: '8px'}}>
                        <Avatar src={item.projectIcon} size={20} >
                          {item.projectName?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        </div>
                        <div className="flex flex-col">
                          <div style={{
                            WebkitLineClamp: 1,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '440px',
                            color: '#FFFFFF'
                          }}>
                            {`${item.type === 'chart' ? item.cardName : item.dashboardName}`}
                          </div>
                          <div style={{
                            WebkitLineClamp: 1,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: '#C1C7D0',
                            fontSize: '12px'
                          }}>
                            {`${item.menuPath?.replace(/,/g, ' > ')}`}
                          </div>
                        </div>
                      </div>
                      {item.hasPermission ? <div className="flex items-center" style={{
                        padding: '2px 8px',
                        backgroundColor: item.type === 'chart' ? '#8388FF12' : '#ffffff20',
                        borderRadius: '4px',
                        fontSize: '12px',
                        color: item.type === 'chart' ? '#8388FF' : '#959DA9',
                      }}>
                        <Icon size={12} name={item.type === 'chart' ? 'ab_chart' : 'ab_dashboard'} style={{marginRight: '4px'}}/>
                        {capitalize(item.type)}
                      </div> : <RequiresPermission />}
                    </List.Item>
                  </Link>
                ))}
              </>
            )}
          </div>
          </>
        )}
        {(searchText) && <Divider style={{margin: '0px 8px', backgroundColor: '#88888828', minWidth: 'auto', width: 'auto'}}/>}
        {renderHotTags()}
        {renderFooter()}
      </Card>
    </div>
  );
};

export default withRouter(SearchResultsModal);
